export default {"src":"/_next/static/media/FanLoginPageImageGIF.f3be552d.gif","height":1200,"width":1200,"blurWidth":0,"blurHeight":0};